(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.__pillTabsInit) {
    window.__pillTabsInit = true;

    var setPillTabs = function (root, index) {
      if (!root) return;
      root.querySelectorAll('[data-pill-tabs-pill]').forEach(function (pill) {
        var on = index !== null && pill.dataset.index === index;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pill-tabs-panel]').forEach(function (panel) {
        panel.hidden = index === null || panel.dataset.index !== index;
      });
    };

    document.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-pill-tabs-pill]');
      if (!pill) return;
      var root = pill.closest('[data-pill-tabs]');
      var isOpen = pill.getAttribute('aria-expanded') === 'true';
      setPillTabs(root, isOpen ? null : pill.dataset.index);
      if (!isOpen && typeof pill.scrollIntoView === 'function') {
        pill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('[data-pill-tabs-panel]');
      if (!panel) return;
      setPillTabs(panel.closest('[data-pill-tabs]'), panel.dataset.index);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var panel = event.target.closest('[data-pill-tabs-panel]');
      if (!panel) return;
      setPillTabs(panel.closest('[data-pill-tabs]'), null);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-circles"] && !Shopify.designMode) return;
  try {
    
  if (!window.__videoCirclesInit) {
    window.__videoCirclesInit = true;

    var closeVideoCircle = function (modal) {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('vc-no-scroll');
      var video = modal.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      var frame = modal.querySelector('iframe');
      if (frame) frame.remove();
    };

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-video-open]');
      if (opener) {
        var modal = document.getElementById(opener.dataset.target);
        if (!modal) return;
        modal.hidden = false;
        document.body.classList.add('vc-no-scroll');

        var player = modal.querySelector('[data-embed-src]');
        if (player && !player.querySelector('iframe')) {
          var frame = document.createElement('iframe');
          frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.src = player.dataset.embedSrc;
          player.appendChild(frame);
        }

        var video = modal.querySelector('video');
        if (video) {
          var attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
        }

        var closeBtn = modal.querySelector('.video-circles__close');
        if (closeBtn) closeBtn.focus();
        return;
      }

      var closer = event.target.closest('[data-video-close]');
      if (closer) {
        closeVideoCircle(closer.closest('[data-video-modal]'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-video-modal]:not([hidden])').forEach(closeVideoCircle);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
